module.exports = __webpack_public_path__ + "img/function-008.1671bcb2.png";